import { merge } from "lodash";
import { Color } from "@glossy/colors";
import { GlossyTheme, PartialTheme } from "@glossy/theme/types";

const mixThemes = (theme: PartialTheme, overload: PartialTheme): GlossyTheme =>
  merge({}, theme, overload) as GlossyTheme;

const baseTheme: PartialTheme = {
  dominant: Color.LightSeaGreen,
  onDominant: Color.White,
  form: {
    include: Color.LightSeaGreen,
    exclude: Color.Cranberry,
  },
  evolution: {
    up: Color.MountainMeadow,
    down: Color.Razzmatazz,
    stable: Color.Downy,
  },
  message: {
    error: Color.Cranberry,
    info: Color.PacificBlue,
    success: Color.LightSeaGreen,
    warning: Color.DarkTangerine,
  },
  chart: {
    primary: Color.PacificBlue,
  },
};

const baseLightTheme: GlossyTheme = mixThemes(baseTheme, {
  content: {
    primary: Color.EastBay,
    secondary: Color.ShipCove,
    tertiary: Color.LinkWater,
  },
  background: Color.White,
  border: Color.LinkWater2,
  form: {
    primary: Color.SlateGrey,
  },
  chart: {
    secondary: Color.LinkWater,
  },
});

const baseDarkTheme: GlossyTheme = mixThemes(baseTheme, {
  content: {
    primary: Color.Solitude2,
    secondary: Color.RockBlue,
    tertiary: Color.SanJuan,
  },
  background: Color.Cinder,
  border: Color.EastBay,
  form: {
    primary: Color.RockBlue,
  },
  chart: {
    secondary: Color.SanJuan,
  },
});

const getTheme = (theme: GlossyTheme, overload?: PartialTheme) =>
  mixThemes(theme, overload);

export const getLightTheme = (overload?: PartialTheme): GlossyTheme =>
  getTheme(baseLightTheme, overload);

export const getDarkTheme = (overload?: PartialTheme): GlossyTheme =>
  getTheme(baseDarkTheme, overload);
